import { render, staticRenderFns } from "./Milestone.vue?vue&type=template&id=453948e2&"
import script from "./Milestone.vue?vue&type=script&lang=ts&"
export * from "./Milestone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports